import { render, staticRenderFns } from "./MaterialCardLogin.vue?vue&type=template&id=15247e1a"
import script from "./MaterialCardLogin.vue?vue&type=script&lang=js"
export * from "./MaterialCardLogin.vue?vue&type=script&lang=js"
import "./MaterialCardLogin.vue?vue&type=style&index=0&id=15247e1a&prod&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports